import markUrl from '../../assets/brand/tonesignature-mark.svg'
import logoUrl from '../../assets/brand/tonesignature-logo.svg'
import monochromeMarkUrl from '../../assets/brand/tonesignature-mark-monochrome.svg'

type LogoVariant = 'full' | 'mark' | 'monochrome'

type LogoProps = {
  variant?: LogoVariant
  size?: number | string
  tagline?: string
  href?: string
  ariaLabel?: string
}

const logoSources: Record<LogoVariant, string> = {
  full: logoUrl,
  mark: markUrl,
  monochrome: monochromeMarkUrl,
}

export function Logo({
  variant = 'full',
  size,
  tagline,
  href = '#top',
  ariaLabel = 'ToneSignature home',
}: LogoProps) {
  const image = <img
    src={logoSources[variant]}
    alt=""
    aria-hidden="true"
    style={size ? { width: typeof size === 'number' ? `${size}px` : size } : undefined}
  />

  const content = <>
    {image}
    {tagline && <span className="logo-tagline">{tagline}</span>}
  </>

  if (!href) {
    return <span className={`logo logo-${variant}`} aria-label="ToneSignature">{content}</span>
  }

  return <a className={`logo logo-${variant}`} href={href} aria-label={ariaLabel}>{content}</a>
}
